import React from 'react'
import { Card, Col, Row } from 'antd'
import { Minimap } from 'gg-editor'

const EditorMinimap = () => {
  return (
    <div>
      <Card type='inner' size='small' title='Minimap' bordered={true}>
        <Minimap height={200} />
      </Card>
      <Card type='inner' size='small' title='All Status' bordered={true}>
        <Col style={{ marginLeft: 20 }}>
          <Row style={{ alignItems: 'center', marginTop: 12 }}>
            <div
              style={{
                width: 15,
                height: 15,
                borderRadius: '50%',
                background: '#07A721',
              }}
            ></div>
            <h5
              style={{
                marginLeft: 8,
              }}
            >
              Done
            </h5>
          </Row>

          <Row style={{ alignItems: 'center', marginTop: 8 }}>
            <div
              style={{
                width: 15,
                height: 15,
                borderRadius: '50%',
                background: '#F79009',
              }}
            ></div>
            <h5
              style={{
                marginLeft: 8,
              }}
            >
              To do
            </h5>
          </Row>

          <Row style={{ alignItems: 'center', marginTop: 8 }}>
            <div
              style={{
                width: 15,
                height: 15,
                borderRadius: '50%',
                background: '#0086C9',
              }}
            ></div>
            <h5
              style={{
                marginLeft: 8,
              }}
            >
              In progress
            </h5>
          </Row>

          <Row style={{ alignItems: 'center', marginTop: 8 }}>
            <div
              style={{
                width: 15,
                height: 15,
                borderRadius: '50%',
                background: '#757575',
              }}
            ></div>
            <h5
              style={{
                marginLeft: 8,
              }}
            >
              Disable
            </h5>
          </Row>
        </Col>
      </Card>
    </div>
  )
}

export default EditorMinimap
